<template>
	<div class="flex justify-content-between align-items-center layout-topbar px-3 py-1">
		<ButtonFloatNavigate class="p-link" @click="onBackButtonClick" />

		<!--    <span class="screen-name"> -->
		<!--      {{ pageStore.currentOptionName }} -->
		<!--    </span> -->

		<!--    <ul class="topbar-menu align-items-center"> -->
		<span class="white-space-nowrap routine-name">
			<b>{{ userStore.currentPageName }}</b>
		</span>
		<!--    </ul> -->
		<div class="flex flex-row align-items-center justify-content-center gap-2">
			<span v-if="!deviceStore.isNative">
				<ButtonMaximizeScreen />
			</span>
			<span v-if="deviceStore.doPing">

				<PingBall />
			</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
	const props = defineProps<{
		topbarMenuActive: boolean;
		activeTopbarItem: string;
		inlineUser: boolean | null | undefined;
	}>();
	const emit = defineEmits(["backbutton-click", "topbar-menubutton-click", "topbar-item-click", "right-menubutton-click"]);
	const pageStore = usePageStore();
	const deviceStore = useDeviceStore();
	const userStore = useUserStore();
	const page = pageStore.tituloPagina;

	function onBackButtonClick(event: Event) {
		emit("backbutton-click", event);
	}
	// function onTopbarMenuButtonClick(event: Event) {
	//     emit('topbar-menubutton-click', event);
	// }
	function onRightMenuButtonClick(event: Event) {
		emit("right-menubutton-click", event);
	}
</script>

<style scoped lang="scss">
	@media (max-width: 240px) {
		.layout-wrapper .layout-topbar .layout-topbar-search {
			input: {
				width: 100% !important
			}
		}

		// .screen-name {
		//   font-size: 6px;
		//   display: none;
		// }
	}

	/* Mesmo degradê do AppTopbar desktop (escuro → claro). */
	.layout-topbar {
		background: linear-gradient(
			105deg,
			#05507f 0%,
			#0772b3 48%,
			#0a9ee0 100%
		) !important;
	}

	.routine-name {
		color: white;
		// font-size: 2rem;
	}

	.screen-name {
		color: white;
		// font-size: 1.4rem
	}
</style>
